var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.accountStatus)?_c('h2',{staticClass:"text-sm m-0 px-2 rounded-full text-white",class:_vm.isActive ? 'bg-green' : 'bg-red'},[_c('span',{domProps:{"textContent":_vm._s('Account Status: ')}}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.accountStatus)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }